import * as Dialog from "@radix-ui/react-dialog";
import "./QRCodeModal.css";
import backgroundImage from "../../../../../assets/img/reel-section/confirmation-qr.png";
import { QRCodeSVG } from "qrcode.react";
import { useGuest } from "../../../../../contexts/GuestContext";
import { useRef } from "react";

export const QRCodeModal = () => {
  const { guest } = useGuest();
  const qrRef = useRef<SVGSVGElement>(null);
  if (!guest) return null;

  const qrValue = guest.token;

  const handleDownload = () => {
    const svg = document.getElementById("qr-code-svg") as SVGSVGElement | null;
    if (!svg || !guest) return;

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg);

    const canvas = document.createElement("canvas");
    canvas.width = 180;
    canvas.height = 180;
    const ctx = canvas.getContext("2d");

    const img = new Image();
    const blob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    img.onload = () => {
      ctx?.drawImage(img, 0, 0);
      URL.revokeObjectURL(url);

      const pngUrl = canvas.toDataURL("image/png");

      const safeName = guest.name
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");

      const link = document.createElement("a");
      link.href = pngUrl;
      link.download = `${safeName}-invitacion.png`;
      link.click();
    };

    img.src = url;
  };

  return (
    <>
      <Dialog.Overlay className="dialog-overlay" />
      <Dialog.Content
        className="dialog-content-qr"
        style={{ height: "97%", backgroundColor: "transparent" }}
      >
        <Dialog.Close asChild>
          <button className="qr-close-button" aria-label="Cerrar modal">
            &times;
          </button>
        </Dialog.Close>
        <div className="qr-confirmation-container">
          <img
            src={backgroundImage}
            alt="Fondo de confirmación"
            className="qr-background"
          />

          <div className="qr-overlay">
            <div className="qr-top-section">
              <span className="qr-thankyou">Gracias por</span>
              <span className="qr-confirmation">TU CONFIRMACIÓN</span>
            </div>

            <QRCodeSVG
              id="qr-code-svg"
              value={qrValue}
              size={180}
              bgColor="#FFFFFF"
              fgColor="#000000"
              className="qr-image"
            />

            <p className="qr-instructions">
              Guarda el código QR y <br />
              muéstralo en la entrada de la <br />
              recepción para asignación de tu <br />
              mesa
            </p>
            <button onClick={handleDownload} className="qr-download-button">
              Descargar QR
            </button>
          </div>
        </div>
      </Dialog.Content>
    </>
  );
};
